export enum TaskStatus {
  Pending = "pending",
  InProgress = "in_progress",
  Completed = "completed",
  Cancelled = "cancelled"
}

export enum TaskPriority {
  Low = "low",
  Medium = "medium",
  High = "high",
  Urgent = "urgent"
}

export interface ITaskComment {
  text: string;
  createdBy: {
    _id: string;
    name: string;
    username: string;
  };
  createdAt: string;
}

export interface ITaskAttachment {
  filename: string;
  originalName: string;
  path: string;
}

export interface ITask {
  _id: string;
  title: string;
  description?: string;
  status: TaskStatus;
  priority: TaskPriority;
  dueDate?: string;
  assignedTo?: {
    _id: string;
    name: string;
    username: string;
  };
  createdBy: {
    _id: string;
    name: string;
    username: string;
  };
  completedAt?: string;
  completedBy?: {
    _id: string;
    name: string;
    username: string;
  };
  tags: string[];
  attachments: ITaskAttachment[];
  comments: ITaskComment[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateTaskRequest {
  title: string;
  description?: string;
  priority?: TaskPriority;
  dueDate?: string;
  assignedTo?: string;
  tags?: string[];
}

export interface UpdateTaskRequest {
  title?: string;
  description?: string;
  status?: TaskStatus;
  priority?: TaskPriority;
  dueDate?: string;
  assignedTo?: string;
  tags?: string[];
}

export interface AddCommentRequest {
  text: string;
}

export interface TaskFilters {
  status?: TaskStatus;
  priority?: TaskPriority;
  assignedTo?: string;
  createdBy?: string;
  dueDateFrom?: string;
  dueDateTo?: string;
  tags?: string[];
}

export interface TaskStats {
  activeTasks: number;
  overdueTasks: number;
  todayTasks: number;
  weekTasks: number;
} 